import { TCommentId, TGetCommentIndex, TCommentListType } from "@/module/comment";
import request from "@/utils/requset";
export const GetItemlist = () => { }

// 添加评论
export const getAddComment = (data: TCommentId) => {
    return request<TCommentId, boolean>({
        url: '/api/user/comments/addcomments',
        method: 'POST',
        data
    })
}
// 评论列表
export const getCommentList = (data: TGetCommentIndex) => {
    return request<TGetCommentIndex, TCommentListType>({
        url: '/api/user/comments/getcommentslist',
        method: 'POST',
        data
    })
}

